import firebase from 'firebase'
import { getQuantity, getToken } from '../helpers'

const state = {
  coin: null,
  coins: null,
  coinsCount: 0,
  coinsByCountry: null,
  coinsByContinent: null,
  errorCoins: null
}

const mutations = {
  setCoin (state, payload) {
    state.coin = payload
  },
  setCoins (state, payload) {
    state.coins = payload
  },
  setCoinsCount (state, payload) {
    state.coinsCount = payload
  },
  setCoinsByCountry (state, payload) {
    state.coinsByCountry = payload
  },
  setCoinsByContinent (state, payload) {
    state.coinsByContinent = payload
  },
  setErrorCoins (state, payload) {
    state.errorCoins = payload
  }
}

const actions = {
  addCoin ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser && payload.data) {
      firebase.database().ref('coins').push().set(payload.data)
    }
  },
  updateCoin ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser && payload.data && payload.key) {
      firebase.database().ref('coins').child(payload.key).update(payload.data)
    }
  },
  deleteCoin ({commit}, payload) {
    let tokenUser = getToken()
    if (tokenUser && payload.key) {
      firebase.database().ref('coins').child(payload.key).remove()
    }
  },
  fetchCoin ({commit}, payload) {
    commit('setCoin', null)
    let tokenUser = getToken()
    if (tokenUser) {
      if (payload !== undefined && payload.key) {
        let promiseCoin = firebase.database().ref('coins').child(payload.key).once('value')
        let promiseBooks = firebase.database().ref('books').once('value')

        Promise.all([promiseCoin, promiseBooks]).then(data => {
          let coin = data[0] ? data[0].val() : null
          let books = data[1] ? data[1].val() : null
          let arrBooks = books ? Object.entries(books).map(([key, value]) => ({key, ...value})).filter(book => book.id === coin.book) : []

          if (arrBooks.length > 0) {
            coin.book = arrBooks[arrBooks.length - 1]
          }
          if (coin.uid === tokenUser) {
            commit('setCoin', coin)
          }
        })
      }
    }
  },
  fetchCoins ({commit}, payload) {
    commit('setCoins', null)
    let tokenUser = getToken()
    if (tokenUser) {
      let promiseCoins = firebase.database().ref('coins')
      if (payload !== undefined) {
        if (payload.countryCode) {
          promiseCoins = promiseCoins.orderByChild('country').equalTo(payload.countryCode)
        }
        if (payload.continentCode) {
          promiseCoins = promiseCoins.orderByChild('continent').equalTo(payload.continentCode)
        }
      }
      promiseCoins = promiseCoins.once('value')
      let promiseBooks = firebase.database().ref('books').once('value')

      Promise.all([promiseCoins, promiseBooks]).then(data => {
        let coins = data[0] ? data[0].val() : null
        let books = data[1] ? data[1].val() : null
        let arrCoins = coins ? Object.entries(coins).map(([key, value]) => ({key, ...value})) : []
        let arrBooks = books ? Object.entries(books).map(([key, value]) => ({key, ...value})) : []
        let coinsUser = arrCoins.length > 0 ? arrCoins.filter(coin => coin.uid === tokenUser) : []

        if (coinsUser.length > 0) {
          for (let i in coinsUser) {
            coinsUser[i].book = arrBooks.filter(book => book.id === coinsUser[i].book)[0]
          }
        }
        commit('setCoins', coinsUser)
      })
    }
  },
  fetchCoinsCount ({commit}) {
    commit('setCoinsCount', 0)
    let tokenUser = getToken()
    if (tokenUser) {
      firebase.database().ref('coins').orderByChild('uid').equalTo(tokenUser).once('value')
        .then(snapshot => {
          let coins = snapshot.val()
          let arrCoins = coins ? Object.entries(coins).map(([key, value]) => ({key, ...value})) : []
          commit('setCoinsCount', getQuantity(arrCoins))
        })
        .catch(err => commit('setErrorCoins', err.message))
    }
  },
  fetchCoinsByCountry ({commit}, payload) {
    commit('setCoinsByCountry', null)
    let tokenUser = getToken()
    if (tokenUser) {
      let promiseCoins = firebase.database().ref('coins').once('value')
      let promiseCountries = firebase.database().ref('countries').once('value')
      let arr = []

      Promise.all([promiseCoins, promiseCountries]).then(data => {
        let coins = data[0].val()
        let countries = data[1].val()
        let arrCoins = Object.entries(coins).map(([key, value]) => ({key, ...value}))

        for (let i in countries) {
          let coinsByCountry = arrCoins.filter(coin => coin.country === countries[i].code && coin.uid === tokenUser)
          arr.push({
            'id': countries[i].code,
            'name': countries[i].name,
            'native': countries[i].native,
            'nbCoins': getQuantity(coinsByCountry)
          })
        }
        commit('setCoinsByCountry', arr)
      })
    }
  },
  fetchCoinsByContinent ({commit}, payload) {
    commit('setCoinsByContinent', null)
    let tokenUser = getToken()
    if (tokenUser) {
      let promiseCoins = firebase.database().ref('coins')
      if (payload.idContinent) {
        promiseCoins = promiseCoins.orderByChild('continent').equalTo(payload.idContinent)
      }
      promiseCoins = promiseCoins.once('value')
      let promiseContinent = firebase.database().ref('continents').once('value')
      let arr = []

      Promise.all([promiseCoins, promiseContinent]).then(data => {
        let coins = data[0].val()
        let continents = data[1].val()
        let arrCoins = Object.entries(coins).map(([key, value]) => ({key, ...value}))

        for (let i in continents) {
          let coinsByContinent = arrCoins.filter(coin => coin.continent === continents[i].code && coin.uid === tokenUser)
          arr.push({
            'id': continents[i].code,
            'name': continents[i].name,
            'nbCoins': getQuantity(coinsByContinent)
          })
        }
        commit('setCoinsByContinent', arr)
      })
    }
  }
}

const getters = {
  coin (state) {
    return state.coin
  },
  coins (state) {
    return state.coins
  },
  coinsCount (state) {
    return state.coinsCount
  },
  coinsByCountry (state) {
    return state.coinsByCountry
  },
  coinsByContinent (state) {
    return state.coinsByContinent
  },
  errorCoins (state) {
    return state.errorCoins
  }
}

export default {
  namespaces: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/coin.js